module.exports = __webpack_public_path__ + "assets/media/lunch.b67690c4.mp3";